export default __webpack_public_path__ + "static/media/bingo-mobile.2b260b77.png";